import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import loadable, { LoadableComponent } from '@loadable/component';

const wordmarkEN = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkEn'
        )
);
const wordmarkDE = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkDe'
        )
);
const wordmarkIT = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkIt'
        )
);
const wordmarkPT = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkPt'
        )
);
const wordmarkFR = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkFr'
        )
);
const wordmarkNL = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkNl'
        )
);
const wordmarkES = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/Logos/99DesignsByVpWordmarkEs'
        )
);

const StyledWordmark = styled.div`
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 40px;
`;

export function Wordmark() {
    const { locale } = useIntl();
    const languageCode = locale.split('-')[0];
    const Logo = wordmarkForLanguageCode(languageCode);
    return (
        <StyledWordmark aria-label={__('99designs by Vistaprint')}>
            <Logo />
        </StyledWordmark>
    );
}

function wordmarkForLanguageCode(
    languageCode: string
): LoadableComponent<React.SVGProps<SVGSVGElement>> {
    switch (languageCode) {
        case 'en':
            return wordmarkEN;
        case 'de':
            return wordmarkDE;
        case 'es':
            return wordmarkES;
        case 'fr':
            return wordmarkFR;
        case 'it':
            return wordmarkIT;
        case 'nl':
            return wordmarkNL;
        case 'pt':
            return wordmarkPT;
        default:
            return wordmarkEN;
    }
}
